// const BASE_API = 'https://ghhis.herokuapp.com/api/v1/';
const BASE_API = 'https://api.auteledoctor.com/api/v1/';
const ERROR_OCCURED = 'Error occured'
 var constant = {
  BASE_API,
  ERROR_OCCURED,
};
export default constant